import * as React from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import {
    API_BASE_URL,
    API_KEY,
  } from '../../constants';
import axiosInstance from '../../axios';
export default function StarterDialog(props) {


  const handleClickOpenStarter = () => {
    props.setOpenStarter(true);
  };

  const handleCloseStarter = () => {

    props.setOpenStarter(false);
  };
  const handleFirstChange = (event) => {
      props.setFirstName(event.target.value);
  };
  const handleLastChange = (event) => {
    props.setLastName(event.target.value);
  };
  const handleEmailChange = (event) => {
    props.setEmail(event.target.value);
  };
  return (
    <React.Fragment>
      <Dialog
        open={props.openStarter}
        onClose={handleCloseStarter}
        PaperProps={{
          component: 'form',
          onSubmit: (event) => {
            event.preventDefault();
            const formData = new FormData(event.currentTarget);
            const formJson = Object.fromEntries((formData).entries());
            let data_to_send={"member_details":{"first_name":formJson.first_name,"last_name":formJson.last_name,"gender":formJson.gender,"member":props.userId},"member":{"member_id":props.userId,"email":formJson.email}}
            // const email = formJson.email;
           console.log(formJson);
            try {
                const response = axiosInstance.put(`${API_BASE_URL}members-all-info/`+props.userId,
                data_to_send).catch(function (error) {
                  if (error.response) {
                    if(error.response.data.errors.errors && error.response.data.errors.errors[0].email)
                      alert(error.response.data.errors.errors[0].email[0]);
                      window.location.reload();
                  }

                });
          
                console.log('API response:', response.data);
                if (response){
                     window.location.reload()
                  }
          
          
              } catch (error) {
                console.error('Error while saving data:', error);
              }
            handleCloseStarter();
          },
        }}
      >
        <DialogTitle>Profile</DialogTitle>
        <DialogContent>
           <TextField
            autoFocus
            name="first_name"
            value={props.first_name}
            placeholder="First Name"
            margin="dense"
            required
            fullWidth
            variant="standard"
            onChange={handleFirstChange}
            />

            <TextField
            name="last_name"
            value={props.last_name}
            placeholder="Last Name"
            margin="dense"
            fullWidth
            variant="standard"
            onChange={handleLastChange}

            />
          <TextField
            margin="dense"
            required
            id="name"
            value={props.email}
            name="email"
            label="Email Address"
            type="email"
            fullWidth
            variant="standard"
            onChange={handleEmailChange}

          />
            <br/><br/>
            <FormControl>
                <FormLabel id="gender">Gender</FormLabel>
                <RadioGroup
                    row
                    aria-labelledby="gender"
                    defaultValue="M"
                    name="gender"
                >
                    <FormControlLabel value="M" control={<Radio />} label="Male" />
                    <FormControlLabel value="F" control={<Radio />} label="Female" />
                    <FormControlLabel value="O" control={<Radio />} label="Other" />
                </RadioGroup>
            </FormControl>
                 
             
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseStarter}>Cancel</Button>
          <Button type="submit">Submit</Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
